/**
 * Coupert - Automatic Coupon Finder & Cashback
 *
 * Leaves a fixed uppercase-hex global in the main world. It looks like a build hash but
 * is stable across page loads, so it works as a marker; the probe pairs it with the
 * resource fallback in case that changes between releases.
 * Observed on version 6.40.89.
 */
import { probeGlobal, probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'mfidniedemcgceagapgdekdbmanojomk';
export const coupert: ExtensionDefinition = {
  id: ID,
  name: 'Coupert - Automatic Coupon Finder & Cashback',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 3_000_000,
  notes:
    'The global marker is an opaque constant rather than a readable name, so it may not ' +
    'survive a rebuild — hence the resource probe alongside it.',
  signals: [
    { id: 'global-coupert-marker', kind: 'global',
      description: 'Check for the window["9AF8D9A4E502F3784AD24272D81F0381"] marker it defines in the main world.',
      weight: 1, run: () => probeGlobal('9AF8D9A4E502F3784AD24272D81F0381') },
    { id: 'war-inject-image', kind: 'web-accessible-resource',
      description: 'Load image/pcp_inject_analyze_type_A.png — a stable resource fallback if the global changes.',
      weight: 1, run: () => probeImage(ID, 'image/pcp_inject_analyze_type_A.png') },
  ],
};
